import React, {Component} from "react";

import cores from '../util/cores'

import BarraTitulo from './BarraTitulo'

import * as texto from '../util/texto'

import {View, Text}  from 'react-native';

import dimens from '../util/dimens'

import {LARGURA_AREA_CONTEUDO} from '../util/constantes'

 


export class ViewDegradeVertical extends Component {

    render() {
        
        return (
            <View style={{flex: 1, backgroundColor:cores.fundo_degrade_fim}}> 
                <View style={{flex: 1, backgroundColor:cores.fundo_degrade_fim}}> 
                    <View style={{backgroundColor:cores.fundo_degrade_fim, alignItems:'center'}}>
                        
                        <View style={{width: LARGURA_AREA_CONTEUDO}}>            
                
                            {(texto.isNotBlanck(this.props.titulo))?
                                (<BarraTitulo titulo ={this.props.titulo} voltar={this.props.voltar} ocultarPontos={this.props.ocultarPontos}/>):
                                (<BarraTitulo>{this.props.dadosBarra}</BarraTitulo>)
                            }
                
                            {this.props.children}
                        </View>
                        
                    </View>
                    <View style={{backgroundColor:cores.fundo_degrade_fim, alignItems:'center'}}> 
                    <Text style={{marginTop:3, 
                            marginBottom:3, 
                            color:cores.fonte_clara, 
                            fontSize:dimens.fonte_rotulo_menor}}>© {new Date().getFullYear()} - B2Negocia</Text>
                    </View>
                </View>
            </View> 
        )
   }
} 



